import cn from 'classnames'
import Image from 'next/image'
import React from 'react'

import {Link} from '@/i18n'
import {HOVER_TRANSITION} from '@/theme/cssTransitions'
import {theme} from '@/theme/theme'
import {QueryLink} from '@/utils/constants'
import {MOBILE_SCREENSIZE} from '@/utils/styles/breakpoints'

type CountryFlagProps = {
  imageSrc: string
  imageAlt: string
  position: {top: string; left: string}
  isHighlighted?: boolean
  link: QueryLink
  onClick: () => void
}

export const CountryFlag: React.FC<React.PropsWithChildren<CountryFlagProps>> = ({
  imageSrc,
  imageAlt,
  position,
  isHighlighted,
  link,
  onClick,
}) => {
  return (
    <>
      <li className={cn('item', isHighlighted && 'highlighted')}>
        <Link href={link} legacyBehavior>
          <a onClick={onClick} role="button" tabIndex={0} className="image-wrapper">
            {/* No priority and no sizes: this section is below the fold, and the flags are SVG,
                which next/image always serves unoptimized — so no srcset is generated. */}
            <Image src={imageSrc} alt={imageAlt} style={{objectFit: 'contain'}} fill />
          </a>
        </Link>
      </li>

      <style jsx>{`
        .item {
          position: absolute;
          top: ${position.top};
          left: ${position.left};
          width: 54px;
          height: 54px;
          border-radius: 50%;
          box-shadow: 0px 0px 0px 1px ${theme.palette.gray[200]};
          transition: all ${HOVER_TRANSITION}ms ease-in-out;
        }

        .item:hover {
          transform: scale(1.12);
        }

        .highlighted {
          width: 80px;
          height: 80px;
        }

        .image-wrapper {
          position: relative;
          display: block;
          width: 100%;
          height: 100%;
        }

        @media ${MOBILE_SCREENSIZE} {
          .item {
            width: 48px;
            height: 48px;
          }

          .highlighted {
            width: 74px;
            height: 74px;
          }
        }
      `}</style>
    </>
  )
}
